import React from 'react';
import { useTranslation } from 'react-i18next';
import { faThumbsUp, faThumbsDown, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import styles from './OverviewRow.module.scss';
import { Icon, Tooltip } from '@benzinga/core-ui';
import { BullBearStatements, RankingDetail } from '@benzinga/quotes-manager';
import { EdgeRanking } from '@benzinga/ticker-ui';
import { BullsVsBears } from './BullVsBear';

interface RatingsProps {
  up: number;
  down: number;
}

interface OverviewRowProps {
  bullSayBearSay: BullBearStatements | null;
  technicals: RatingsProps;
  financials: RatingsProps;
  className?: string;
  symbol: string;
  rankingData?: RankingDetail | null;
}

const getRatingTextAndColor = (down: number, up: number, t: (key: string, options?: { ns?: string }) => string) => {
  const total = down + up;
  const rating = up / total;
  if (rating > 0.9) {
    return { color: 'text-green-500', text: t('Quote.Analysis.status.very-promising', { ns: 'quote' }) };
  }
  if (rating > 0.75) {
    return { color: 'text-green-500', text: t('Quote.Analysis.status.promising', { ns: 'quote' }) };
  }
  if (rating > 0.5) {
    return { color: 'text-green-500', text: t('Quote.Analysis.status.good', { ns: 'quote' }) };
  }
  if (rating > 0.25) {
    return { color: 'text-red-500', text: t('Quote.Analysis.status.speculative', { ns: 'quote' }) };
  }
  return { color: 'text-red-500', text: t('Quote.Analysis.status.speculative', { ns: 'quote' }) };
};

export const OverviewRow = ({ bullSayBearSay, financials, rankingData, symbol, technicals }: OverviewRowProps) => {
  const { t } = useTranslation(['quote', 'common']);

  const ratings = {
    down: technicals.down + financials.down,
    up: technicals.up + financials.up,
  };

  const { color, text } = getRatingTextAndColor(ratings.down, ratings.up, t);

  const technicalAnalysisRating = Math.floor((technicals.up / (technicals.down + technicals.up)) * 100);
  const financialAnalysisRating = Math.floor((financials.up / (financials.down + financials.up)) * 100);

  // if (!technicalAnalysisRating || !financialAnalysisRating) {
  //   return null;
  // }

  const isEnd = value => {
    if (value < 5) {
      return 'hide-start';
    }
    if (value > 95) {
      return 'hide-end';
    }
    return '';
  };

  return (
    <div className={styles.overviewRowWrapper}>
      {/* <OverviewCardWrapper className="flex gap-2 justify-between overview-section">
        <div className="flex flex-row md:justify-normal w-full">
          <SectionRating className="ratings-circle w-[80px] h-[80px]" down={ratings.down} up={ratings.up} />
          <div className="flex flex-col gap-0 md:ml-12 justify-center">
            <div className="font-bold text-gray-600 overview-title">{t('Quote.Analysis.overview-rating')} 12121212</div>
            <div className={`${color} font-semibold text-xl`}>{text}</div>
          </div>
        </div>
      </OverviewCardWrapper> */}

      {rankingData && (
        <div className="flex flex-row gap-2 pb-2">
          <h6 className="uppercase pb-0">Edge Rankings</h6>
          <Tooltip
            content={
              'Benzinga Edge stock rankings give you four critical scores to help you identify the strongest and weakest stocks to buy and sell.'
            }
            width={250}
          >
            <Icon
              className="info-circle-icon text-sm flex items-center justify-center text-[#99AECC]"
              icon={faInfoCircle}
            />
          </Tooltip>
        </div>
      )}

      <div className="edge-items-wrapper flex gap-4">
        {/* {rankingData && <EdgeRankings rankingData={rankingData} />} */}
        {rankingData && (
          <EdgeRanking {...rankingData} adType="quotepage" layout="quote" symbol={symbol} variant="dark" />
        )}
        <div className="bull-vs-bears-wrapper">
          <BullsVsBears statements={bullSayBearSay} symbol={symbol} />
        </div>
      </div>
      {/* <OverviewCardWrapper $height={130}>
        <div className="ratings-section">
          {!!technicalAnalysisRating && (
            <div className={`range-indicator-wrapper ${isEnd(technicalAnalysisRating)}`}>
              <InfoTooltip
                title={t('Quote.Analysis.technicals-analysis', { ns: 'quote' })}
                tooltipContent={t('Quote.Analysis.technicals-analysis-content')}
              />
              <RangeIndicator value={technicalAnalysisRating} />
            </div>
          )}
          {!!technicalAnalysisRating && !!financialAnalysisRating && <Divider />}
          {!!financialAnalysisRating && (
            <div className={`range-indicator-wrapper ${isEnd(financialAnalysisRating)}`}>
              <InfoTooltip
                title={t('Quote.Analysis.financials-analysis', { ns: 'quote' })}
                tooltipContent={t('Quote.Analysis.financials-analysis-content')}
              />
              <RangeIndicator value={financialAnalysisRating} />
            </div>
          )}
        </div>
        <GetReportButton className="w-full mt-2.5 text-sm uppercase" ticker={symbol} variant="flat-light-blue" />
      </OverviewCardWrapper> */}
    </div>
  );
};

export default OverviewRow;

const Divider = () => {
  return (
    <div className={styles.dividerWrapper}>
      <div className="divider" />
    </div>
  );
};


export const Thumb = (props: { up?: boolean; down?: boolean }) => {
  const { down, up } = props;
  if (up) {
    return (
      <div className={`${styles.thumbWrapper} up`}>
        <Icon
          icon={faThumbsUp}
          style={{
            color: '#30bf60',
          }}
        />
      </div>
    );
  }
  if (down) {
    return (
      <div className={`${styles.thumbWrapper} down`}>
        <Icon
          icon={faThumbsDown}
          className="text-sm"
          style={{
            color: '#ff4050',
          }}
        />
      </div>
    );
  }
  return null;
};

